import { createRouter, createWebHistory } from 'vue-router';
import Layout from '../components/layouts/TenantLayout.vue';
import TenantServicesIndex from '../components/TenantServicesIndex.vue';
import ServiceDetails from '../components/ServiceDetails.vue';
import ForgotPassword from '../components/ForgotPassword.vue';
import ResetPassword from '../components/ResetPassword.vue';
import Invoices from '../components/Invoices.vue';
import Transactions from '../components/Transactions.vue';
import Rooms from '../components/Rooms.vue';
import Apartments from '../components/Apartments.vue';
import Services from '../components/Services.vue';
import EmptyRooms from '../components/EmptyRooms.vue';
import Tickets from '../components/Tickets.vue';
import ApartmentsManagement from '../components/layouts/ApartmentManagementLayout.vue';
import Dashboard from '../components/apartment/Dashboard.vue';
import ApartmentRooms from '../components/apartment/Rooms.vue';
import ApartmentInvoices from '../components/apartment/Invoices.vue';
import ApartmentUsers from '../components/apartment/Users.vue';
import RoomDetails from '../components/apartment/RoomDetails.vue';
import ErrorPage from '../components/ErrorPage.vue'; // Import ErrorPage if needed
import TenantRoomDetails from '../components/apartment/RoomDetails.vue';
import InvoiceDetail from '../components/InvoiceDetail.vue';

// import AddUnitComponent from '../components/plantation/units/AddUnitComponent.vue';
// import TasksComponent from '../components/plantation/tasks/TasksComponent.vue';
// import ShipmentsComponent from '../components/plantation/shipments/ShipmentsComponent.vue';
// import HarvestsComponent from '../components/plantation/harvests/HarvestsComponent.vue';
// import WorkersComponent from '../components/plantation/workers/WorkersComponent.vue';


// import AddUnit from '../components/plantation/units/AddUnitComponent.vue';
// import Units from '../components/plantation/units/UnitsComponent.vue';
// import Workers from '../components/plantation/workers/WorkersComponent.vue';
// import Factories from '../components/plantation/factories/FactoriesComponent.vue';
// import Harvests from '../components/plantation/harvests/HarvestsComponent.vue';
// import Shipments from '../components/plantation/shipments/ShipmentsComponent.vue';
// import Tasks from '../components/plantation/tasks/TasksComponent.vue';

import UnitsComponent from '../components/plantation/units/UnitsComponent.vue';
import AddUnitComponent from '../components/plantation/units/AddUnitComponent.vue';
import EditUnitComponent from '../components/plantation/units/EditUnitComponent.vue';

import WorkersComponent from '../components/plantation/workers/WorkersComponent.vue';
import AddWorkerComponent from '../components/plantation/workers/AddWorkerComponent.vue';
import EditWorkerComponent from '../components/plantation/workers/EditWorkerComponent.vue';

import SuppliersComponent from '../components/plantation/suppliers/SupplierComponent.vue';
import AddSupplierComponent from '../components/plantation/suppliers/AddSupplierComponent.vue';
import EditSupplierComponent from '../components/plantation/Suppliers/EditSupplierComponent.vue';

import FactoriesComponent from '../components/plantation/factories/FactoriesComponent.vue';
import AddFactoryComponent from '../components/plantation/factories/AddFactoryComponent.vue';
import EditFactoryComponent from '../components/plantation/factories/EditFactoryComponent.vue';

import HarvestsComponent from '../components/plantation/harvests/HarvestsComponent.vue';
import AddHarvestComponent from '../components/plantation/harvests/AddHarvestComponent.vue';
import EditHarvestComponent from '../components/plantation/harvests/EditHarvestComponent.vue';

import ShipmentsComponent from '../components/plantation/shipments/ShipmentsComponent.vue';
import AddShipmentComponent from '../components/plantation/shipments/AddShipmentComponent.vue';
import EditShipmentComponent from '../components/plantation/shipments/EditShipmentComponent.vue';

import TasksComponent from '../components/plantation/tasks/TasksComponent.vue';
import AddTaskComponent from '../components/plantation/tasks/AddTaskComponent.vue';
import EditTaskComponent from '../components/plantation/tasks/EditTaskComponent.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../components/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../components/Register.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/error',
    name: 'ErrorPage',
    component: ErrorPage // Ensure ErrorPage is imported correctly
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../components/Dashboard.vue'),
        meta: { requiresAuth: true } ,
      },
     // Units
  { path: '/units', name: 'Units', component: UnitsComponent },
  { path: '/units/add', name: 'AddUnit', component: AddUnitComponent },
  { path: '/units/edit/:id', name: 'EditUnit', component: EditUnitComponent, props: true },

  // Suppliers
  { path: '/Suppliers', name: 'Suppliers', component: SuppliersComponent },
  { path: '/Suppliers/add', name: 'AddSupplier', component: AddSupplierComponent },
  { path: '/Suppliers/edit/:id', name: 'EditSupplier', component: EditSupplierComponent, props: true },
  {
  path: '/supplier/:id',
  name: 'SupplierDetails',
  component: () => import('../components/plantation/suppliers/SupplierDetails.vue'),
},


   // Workers
  { path: '/workers', name: 'Workers', component: WorkersComponent },
  { path: '/workers/add', name: 'AddWorker', component: AddWorkerComponent },
  { path: '/workers/edit/:id', name: 'EditWorker', component: EditWorkerComponent, props: true },

  // Factories
  { path: '/factories', name: 'Factories', component: FactoriesComponent },
  { path: '/factories/add', name: 'AddFactory', component: AddFactoryComponent },
  { path: '/factories/edit/:id', name: 'EditFactory', component: EditFactoryComponent, props: true },

  // Harvests
  { path: '/harvests', name: 'Harvests', component: HarvestsComponent },
  { path: '/harvests/add', name: 'AddHarvest', component: AddHarvestComponent },
  { path: '/harvests/edit/:id', name: 'EditHarvest', component: EditHarvestComponent, props: true },

  // Shipments
  { path: '/shipments', name: 'Shipments', component: ShipmentsComponent },
  { path: '/shipments/add', name: 'AddShipment', component: AddShipmentComponent },
  { path: '/shipments/edit/:id', name: 'EditShipment', component: EditShipmentComponent, props: true },
  {
  path: '/shipments/:id',
  name: 'ShipmentDetails',
  component: () => import('../components/plantation/shipments/ShipmentDetails.vue'),
},
  // Tasks
  { path: '/tasks', name: 'Tasks', component: TasksComponent },
  { path: '/tasks/add', name: 'AddTask', component: AddTaskComponent },
  { path: '/tasks/edit/:id', name: 'EditTask', component: EditTaskComponent, props: true },
  { path: '/:pathMatch(.*)*', redirect: '/dashboard' }, // fallback,
      {
        path: 'tenantservices',
        name: 'tenantservices.index',
        component: TenantServicesIndex
      },
      {
        path: 'service/:id',
        name: 'service.details',
        component: ServiceDetails,
        props: true
      },
      {
        path: 'tickets',
        name: 'Tickets',
        component: Tickets
      },
      {
        path: 'reset-password',
        name: 'ResetPassword',
        component: ResetPassword
      },
      {
        path: 'invoices',
        name: 'Invoices',
        component: Invoices,
      },
      {
        path: '/invoices/:id',
        name: 'InvoiceDetail',
        component: InvoiceDetail,
      },
      {
        path: 'transactions',
        name: 'Transactions',
        component: Transactions,
      },
      {
        path: 'rooms',
        name: 'Rooms',
        component: Rooms,
      },
      {
        path: 'apartments',
        name: 'Apartments',
        component: Apartments,
      },
      {
        path: 'services',
        name: 'Services',
        component: Services,
      },
      {
        path: 'marketplace',
        name: 'EmptyRooms',
        component: EmptyRooms,
      },
    ]
  },
  {
    path: '/manage',
    component: ApartmentsManagement,
    children: [
      { path: '', name: 'ManageDashboard', component: Dashboard },
      { path: 'rooms', name: 'ApartmentRooms', component: ApartmentRooms },
      { path: 'invoices', name: 'ApartmentInvoices', component: ApartmentInvoices },
      { path: 'users', name: 'ApartmentUsers', component: ApartmentUsers },
      {
        path: 'rooms/:id',
        name: 'RoomDetails',
        component: RoomDetails,
      },
      {
        path: '/tenant-room/:id',
        name: 'tenant-room.details',
        component: TenantRoomDetails,
        props: true, // Enables passing route params as props
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Navigation guard for authentication checks
router.beforeEach((to, from, next) => {
    let user = null;

    // Attempt to retrieve user from localStorage
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        user = JSON.parse(userData);
      } catch (e) {
        console.error("Error parsing user data from localStorage", e);
        // Optionally handle the error by resetting the user data in localStorage
        localStorage.removeItem('user');
      }
    }

    // Allow access to login, forgot-password, and register routes if not authenticated
    if (!user && (to.name === 'Login' || to.name === 'ForgotPassword' || to.name === 'Register')) {
      return next(); // Allow access to these routes
    }

    // Redirect authenticated users away from login and register pages
    if (user && (to.name === 'Login' || to.name === 'Register')) {
      return next({ name: 'Dashboard' });
    }

    // Allow access to other routes if user is authenticated
    next();
  });

  export default router;
